import React, { FC } from 'react';
import { FolderThumbnail } from '../../../../../../components/common';
import { THUMBNAIL_SIZE } from '../../../../../../components/common/Thumbnails/constants';
import styles from '../Thumbnails.scss';
import { IOuter } from './Folder.types';

export const Folder: FC<IOuter> = ({ item }) => (
  <div className={styles.folderThumbnailWrapper} data-hook="single-folder-top-part">
    <FolderThumbnail className={styles.folderThumbnail} folder={item} {...THUMBNAIL_SIZE} />
  </div>
);
